@if (required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        class='weaveInput'
        [type]="'number'"
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut()"
        (focusout)="onFocusOut()"
        (keyup)="onKeyUp()"
        (keydown.enter)='$event.target.blur()'
        [(ngModel)]='data'
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        required
        #ctrl="ngModel"
      >
      <mat-error *ngIf="ctrl.invalid && ctrl.touched">
        {{label || "This field"}} is required
      </mat-error>
    </mat-form-field>
  </div>
}
@if (!required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        class='weaveInput'
        [type]="'number'"
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut()"
        (focusout)="onFocusOut()"
        (keyup)="onKeyUp()"
        (keydown.enter)='$event.target.blur()'
        [(ngModel)]='data'
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
      >
    </mat-form-field>
  </div>
}
